import { render, staticRenderFns } from "./fund-table.vue?vue&type=template&id=c8e7af22&scoped=true&"
import script from "./fund-table.vue?vue&type=script&lang=js&"
export * from "./fund-table.vue?vue&type=script&lang=js&"
import style0 from "./fund-table.vue?vue&type=style&index=0&id=c8e7af22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e7af22",
  null
  
)

export default component.exports